export default __webpack_public_path__ + "static/media/storageUnit1-afterD-480w.eeee11f3.webp";